<template>
  <div>
    <v-card class="mx-auto mb-5">
      <v-card-text class="pa-5 black--text">
        <v-row class="mx-2 my-3">
          <v-col cols="12">
            <div class="body-1 font-weight-medium">
              Apakah Anda melaksanakan kegiatan pendampingan kelompok ?
            </div>
            <v-radio-group v-model="isTerlaksana" :disabled="readOnly" row dense class="mt-0" hide-details>
              <v-radio label="Ya" value="1"></v-radio>
              <v-radio label="Tidak" value="0"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mx-auto" v-if="+isTerlaksana === 1">
      <v-card-text class="pa-5 black--text">
        <v-row class="mx-2 my-3">
          <v-col cols="12">
            <div class="body-1 font-weight-medium">
              Informasi Umum
            </div>
            <base-form-generator :schema="schema.pelapor" v-model="form" class="pt-4" />
            <v-row v-if="schema.tipePelapor" class="pt-3 pb-2">
              <v-col cols="12" lg="6">
                <base-form-radio
                  v-model="form.k_teaching_psp"
                  label="Strategi pengelolaan kelas"
                  label-color="indigo"
                  :items="mKpOpsiPspTeachingPsp"
                  :hide-details="true"
                />
              </v-col>
              <v-col v-if="isLaporan2024 && !isLaporanRefleksi2024" cols="12" lg="6">
                <div class="indigo--text mb-1"> Pembagian Kelas Lokakarya <span class="red--text">*</span> </div>
                <v-select
                  v-model="form['k_jenjang_kelas_psp']"
                  :items="mKpOpsiPspJenjangKelasPsp"
                  placeholder="Pilih cara pembagian kelas lokakarya"
                  outlined
                  dense
                  single-line
                  hide-details
                ></v-select>
              </v-col>
              <v-col v-if="+form.k_teaching_psp === 62" cols="12" lg="6">
                <div class="px-0 body-2 indigo--text" style="min-height: 24px">
                  Fasilitator di dalam kelas lokakarya (lainnya)
                </div>
                <div v-if="$isObject(fspLain)" class="mb-3 black--text grey lighten-3 pa-2">
                  <v-row no-gutters>
                    <v-col cols="12" lg="8" class="flex-grow-0 flex-shrink-0 my-auto">
                      <span class="text-left">{{ $getDeepObj(fspLain, 'ptk.nama') }}</span>
                    </v-col>
                    <v-col
                      cols="1"
                      style="min-width: 100px; max-width: 100%;"
                      class="flex-grow-1 flex-shrink-0 text-right"
                    >
                      <v-btn small color="primary" class="text-capitalize" @click="onSelectFsp">
                        <v-icon left>mdi-account-search</v-icon> Ganti Fasilitator
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
                <div v-else>
                  <v-btn color="primary" class="text-capitalize" @click="onSelectFsp">
                    <v-icon left>mdi-account-search</v-icon> Pilih Fasilitator
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <base-form-generator :schema="schema.pelaksanaan" v-model="form" class="pt-4" />
          </v-col>
          <v-col v-if="schema.peserta && schema.peserta.length" cols="12">
            <div class="body-1 font-weight-medium">
              Jumlah Peserta
            </div>
            <v-alert dense colored-border color="secondary" border="left" class="light-blue lighten-5 mt-1 mb-1">
              Jika tidak terdapat peserta pada kolom jenjang yang tersedia dari sistem, silakan mengisikan dengan angka
              0
            </v-alert>
            <base-form-generator :schema="schema.peserta" v-model="form" class="pt-2" />
          </v-col>
          <v-col v-if="schema.deskripsi" cols="12">
            <div class="body-1 font-weight-medium">Deskripsi Kegiatan</div>
            <base-form-generator :schema="schema.deskripsi" v-model="form" class="pt-4" />
          </v-col>
          <v-col v-if="schema.instrumens" cols="12">
            <div class="body-1 font-weight-medium">Pelaksanaan Kegiatan</div>
            <base-form-generator :schema="schema.instrumens" v-model="form" class="pt-2" />
          </v-col>
          <v-col v-if="schema.linkaksi">
            <base-form-generator class="mt-4" :schema="schema.linkaksi" v-model="form.rencana_url" />
          </v-col>
          <v-col v-if="+kKegiatan === 31" cols="12">
            <div class="body-1 font-weight-medium mb-2">
              Sekolah dengan rentang nilai PKP antara 0 sampai 50
            </div>
            <div>
              <div class="body-2 grey--text text--darken-1">
                Apakah Anda mendampingi sekolah dengan rentang nilai PKP antara 0 sampai 50?
              </div>
              <v-radio-group v-model="isDampinganSekolah" row dense class="mt-0" hide-details>
                <v-radio label="Ya" value="1"></v-radio>
                <v-radio label="Tidak" value="0"></v-radio>
              </v-radio-group>
              <template v-if="+isDampinganSekolah === 1">
                <div class="body-2 grey--text text--darken-1 mt-6">
                  Pilih daftar sekolah dengan rentang nilai PKP antara 0 sampai 50
                </div>
                <div class="mt-1">
                  <template v-if="!sekolah.length">
                    <v-btn class="text-capitalize" color="primary" depressed @click="onPilihSekolah">
                      <v-icon left>mdi-home</v-icon> Pilih Sekolah
                    </v-btn>
                  </template>
                  <template v-else>
                    <v-list>
                      <v-list-item dense class="px-0" v-for="(item, id) in sekolah" :key="id">
                        <v-list-item-avatar color="secondary">
                          <v-icon dark>mdi-home</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <div class="blue--text">{{ item.nama }}</div>
                          <div><strong>NPSN: </strong> {{ item.npsn }}</div>
                          {{ item.sekolah_id }}
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                    <v-btn class="text-capitalize" color="primary" depressed @click="onPilihSekolah">
                      <v-icon left>mdi-pencil</v-icon> Ubah Pilihan Sekolah
                    </v-btn>
                  </template>
                </div>
                <div class="body-2 grey--text text--darken-1 mt-7">
                  Tuliskan aktivitas pendampingan yang sudah dilakukan untuk sekolah dampingan dengan rentang nilai PKP
                  antara 0 sampai 50.
                </div>
                <v-textarea v-model="form.pkp_aktivitas" outlined rows="3" auto-grow />
                <div class="body-2 grey--text text--darken-1">
                  Tuliskan perkembangan atau hasil pendampingan yang sudah dilakukan untuk sekolah dampingan dengan
                  rentang skor nilai PKP antara 0 sampai 50.
                </div>
                <v-textarea v-model="form.pkp_hasil" outlined rows="3" hide-details auto-grow />
              </template>
            </div>
          </v-col>
          <v-col cols="12">
            <div
              v-if="form.k_lokakarya_moda_psp === 1 || (schema.berkas || []).filter((sch) => sch.kBerkas !== 6).length"
            >
              <div class="body-1 font-weight-medium">Lampiran</div>
            </div>
            <v-row class="mt-1">
              <template v-for="(berkas, b) in schema.berkas">
                <v-col :key="b" cols="12" v-if="berkas.kBerkas">
                  <div class="body-2 indigo--text text-capitalize"> {{ berkas.label }} </div>
                  <div class="body-2 grey--text text--darken-1" v-if="berkas.desc" v-html="berkas.desc"></div>
                  <v-row class="mt-1">
                    <v-col v-if="(berkas.berkases || []).length" cols="12" sm="12" md="12" class="pt-1">
                      <v-row v-for="(file, f) in berkas.berkases" :key="f" dense>
                        <v-col cols="12" md="9" sm="12">
                          <div class="grey lighten-3 pa-2 black--text">{{ file.judul }}</div>
                        </v-col>
                        <v-col cols="12" md="3" sm="12" class="my-auto">
                          <div>
                            <v-btn
                              color="success"
                              class="text-capitalize"
                              depressed
                              :disabled="!file.url_berkas"
                              :href="file.url_berkas"
                              target="_blank"
                            >
                              <v-icon left>mdi-eye</v-icon>
                              Lihat
                            </v-btn>
                            <v-btn
                              v-if="file.is_reupload"
                              class="mx-1"
                              color="blue"
                              dark
                              depressed
                              @click="onReuploadBerkas(berkas, file)"
                            >
                              <v-icon left>mdi-upload</v-icon>
                              Unggah
                            </v-btn>
                            <v-btn
                              v-if="!readOnly"
                              class="mx-1 text-capitalize"
                              color="red"
                              dark
                              depressed
                              @click="onDelBerkas(file)"
                            >
                              <v-icon left>mdi-delete</v-icon>
                              Hapus
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="py-0 mb-4">
                      <v-btn
                        v-if="!readOnly"
                        color="primary"
                        class="text-capitalize"
                        :disabled="berkas.berkases.length >= (berkas.max || 5)"
                        @click="onAddBerkas(berkas)"
                        depressed
                      >
                        <v-icon left>mdi-plus</v-icon> Tambah Berkas
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </template>
              <v-col v-if="form.k_lokakarya_moda_psp === 1" cols="12" md="12" sm="12">
                <div v-if="!(form.rekaman_data || []).length" class="px-0 body-2 indigo--text" style="min-height: 24px">
                  Rekaman Video Conference taruh URL, video rekaman disini
                </div>
                <template v-for="(meeting, m) in form.rekaman_data">
                  <v-row :key="m" no-gutters class="mt-2">
                    <v-col cols="12" :md="readOnly ? 10 : 9" sm="12">
                      <base-form-generator
                        :key="m"
                        :schema="schema.meetings"
                        v-model="form.rekaman_data[m]"
                        @input="getDurasi(form.rekaman_data[m], m)"
                      />
                    </v-col>
                    <v-col v-if="!readOnly" cols="12" md="3" sm="12">
                      <div class="mt-6 ml-2">
                        <v-btn color="error" depressed @click="onDelRekaman(m)">
                          <v-icon left>mdi-delete</v-icon> Hapus
                        </v-btn>
                        <span class="blue--text pa-3">
                          {{ (durasis && durasis[Number(m)]) || '' }}
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </template>
                <v-btn
                  v-if="!readOnly"
                  @click="onAddRekaman"
                  color="primary"
                  depressed
                  class="text-capitalize"
                  :disabled="form.rekaman_data.length === 5"
                >
                  <v-icon left dark>
                    mdi-plus
                  </v-icon>
                  Tambah Tautan Rekaman
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col v-if="(schema.instrumensIht || []).length" cols="12">
            <div class="body-1 font-weight-medium">Tambahan terkait IHT Pengawas</div>
            <base-form-generator :schema="schema.instrumensIht" v-model="form" class="pt-2" />
          </v-col>
          <v-col v-if="(schema.instrumensPmo || []).length" cols="12">
            <div class="body-1 font-weight-medium">Monitoring PMO Level Sekolah</div>
            <base-form-generator :schema="schema.instrumensPmo" v-model="form" class="pt-2" />
          </v-col>
        </v-row>
      </v-card-text>
      <berkas
        ref="berkas"
        :jenis="berkas.jenis"
        :title="berkas.title"
        :reupload="berkas.reupload"
        @upload="onAddBerkasSave"
      />
      <sekolah-kandidat :kp-pa-id="pspKpPa.psp_kp_pa_id" ref="kandidat" />
      <base-list-popup
        ref="kandidat"
        title="Daftar Fasilitator"
        :api="`lokakarya/getFasilitator`"
        :id="pspKpPa.psp_kp_pa_id"
        :options="{ gelombang: pspKpPa.gelombang, mGelombang: gelombangPendampingan }"
      />
    </v-card>
  </div>
</template>
<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';
import BaseFormRadio from '@components/base/BaseFormRadio';
import BaseListPopup from '@components/base/BaseListPopup';
import Berkas from '../components/Berkas';
import SekolahKandidat from '../components/Sumber';
import Schema from '../instrumen/KpPaLokakarya';
import { mapActions, mapState } from 'vuex';

export default {
  mixins: [Schema],
  components: { BaseFormGenerator, BaseFormRadio, BaseListPopup, Berkas, SekolahKandidat },
  props: {
    initValue: {
      type: Object,
      default: () => null,
    },
    masters: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default: () => {},
    },
    meta: {
      type: Object,
      default: () => {},
    },
    kKegiatan: {
      type: [Number, String],
      default: '',
    },
    keyInstrumen: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {},
      sekolah: [],
      berkas: { title: '', jenis: '', reupload: false },
      durasis: [],
      isDampinganSekolah: null,
      isTerlaksana: null,
      fspLain: {},
    };
  },
  computed: {
    ...mapState('preferensi', {
      preferensi: (state) => state.data,
      configPendampingan: (state) => (state.data && state.data.pendampingan && state.data.pendampingan['kp-pa']) || {},
    }),

    isLaporan2023() {
      const tahunKe = { 1: 3, 2: 2, 3: 1 };
      return +this.pspKpPa['tahun_ke'] >= tahunKe[this.pspKpPa.gelombang];
    },

    isLaporan2024() {
      const tahunKe = { 1: 3, 2: 3, 3: 2 };
      return +this.pspKpPa['tahun_ke'] >= tahunKe[this.pspKpPa.gelombang];
    },

    isLaporanRefleksi2024() {
      return [122, 123, 143, 144].includes(this.kKegiatan);
    },

    gelombangPendampingan() {
      return (this.configPendampingan.gelombang || []).reverse().map((gelombang) => {
        return {
          text: `Angkatan ${gelombang}`,
          value: gelombang,
        };
      });
    },

    pspKpPa() {
      return this.$getDeepObj(this.meta, 'kp_pa.0') || {};
    },

    mKpOpsiPspTeachingPsp() {
      const label2023 = {
        61: '1 FSP memfasilitasi 1 kelas',
        62: '2 FSP memfasilitasi 1 kelas',
      };

      return Object.keys(this.masters.kp_opsi_psp || {})
        .filter((kKpOpsiPsp) => ['61', '62'].includes(kKpOpsiPsp))
        .map((kKpOpsiPsp) => {
          return {
            text: this.isLaporan2023 ? label2023[kKpOpsiPsp] : this.masters.kp_opsi_psp[kKpOpsiPsp],
            value: +kKpOpsiPsp,
          };
        });
    },

    mKpOpsiPspDurasiPsp() {
      return Object.keys(this.masters.kp_opsi_psp || {})
        .filter((kKpOpsiPsp) => ['63', '64'].includes(kKpOpsiPsp))
        .map((kKpOpsiPsp) => {
          return {
            text: this.masters.kp_opsi_psp[kKpOpsiPsp],
            value: +kKpOpsiPsp,
          };
        });
    },

    mKpOpsiPspJenjangKelasPsp() {
      return Object.keys(this.masters.kp_opsi_psp || {})
        .filter((kKpOpsiPsp) => ['81', '82', '83'].includes(kKpOpsiPsp))
        .map((kKpOpsiPsp) => {
          return {
            text: this.masters.kp_opsi_psp[kKpOpsiPsp],
            value: +kKpOpsiPsp,
          };
        });
    },
  },
  methods: {
    ...mapActions('preferensi', ['cekRekaman']),
    ...mapActions('lokakaryaPa', ['upload', 'delete', 'getFasilitator']),

    initForm(value) {
      if (!value || !this.$isObject(value || {})) return;
      const formulir = [
        ...(this.schema.pelapor || []),
        ...(this.schema.pelaksanaan || []),
        ...(this.schema.peserta || []),
        ...(this.schema.deskripsi || []),
      ];

      this.$set(
        this,
        'isTerlaksana',
        Object.keys(value).includes('is_terlaksana') ? (+value.is_terlaksana === 1 ? '1' : '0') : '1'
      );

      for (const item of formulir) {
        if (item.name) {
          this.$set(
            this.form,
            item.name,
            typeof value[item.name] === 'number' ? Number(value[item.name]) : this.$getDeepObj(value, item.name) || ''
          );
        }
      }

      // Init Meeting URL
      const meeting = this.$getDeepObj(value, 'rekaman_data') || [];
      if (meeting.length > 0) {
        this.$set(this.form, 'rekaman_data', []);
        let formMeeting = [];

        meeting.forEach((item, index) => {
          formMeeting.push(item);
          this.durasis[index] = this.$durasiWaktu(this.$getDeepObj(item, 'durasi')) || null;
        });

        this.$set(this.form, 'rekaman_data', formMeeting);
      }

      const keys = ['rencana_url', 'k_propinsi', 'k_kota', 'k_teaching_psp', 'k_jenjang_kelas_psp'];
      for (const key of keys) {
        if (value[key]) {
          this.$set(this.form, key, value[key]);
        }
      }

      this.fspLain = {};
      if (value.psp_profil_id_lain) {
        this.fspLain = value.psp_profil_lain;
      }

      const instrumens =
        this.$getDeepObj(value, 'psp_kp_pa_lokakarya_instrumens.data') || value.psp_kp_pa_lokakarya_instrumens || [];
      if (instrumens.length) {
        let result = {};
        for (const ins of instrumens) {
          const tipe =
            this.$getDeepObj(ins, 'm_lokakarya_instrumen_psp.data.tipe') ||
            this.$getDeepObj(ins, 'm_lokakarya_instrumen_psp.tipe') ||
            '';

          if (tipe === 'checkbox') {
            if (result[`instrumen-${tipe}-${ins.k_lokakarya_instrumen_psp}`]) {
              result[`instrumen-${tipe}-${ins.k_lokakarya_instrumen_psp}`].push(ins.k_lokakarya_opsi_psp);
            } else {
              result[`instrumen-${tipe}-${ins.k_lokakarya_instrumen_psp}`] = [ins.k_lokakarya_opsi_psp];
            }
          } else if (tipe === 'radio') {
            result[`instrumen-${tipe}-${ins.k_lokakarya_instrumen_psp}`] = ins.k_lokakarya_opsi_psp;
          } else {
            result[`instrumen-input-${ins.k_lokakarya_instrumen_psp}`] = ins.isian || '';
          }

          if (ins.isian) {
            this.$set(this.form, `input-lain-${ins.k_lokakarya_instrumen_psp}-${ins.k_lokakarya_opsi_psp}`, ins.isian);
          }
        }

        for (const rs in result) {
          this.$set(this.form, rs, result[rs]);
        }
      }

      if (+this.kKegiatan === 31) {
        this.form.pkp_aktivitas = value['pkp_aktivitas'] || '';
        this.form.pkp_hasil = value['pkp_hasil'] || '';
        this.sekolah = (value['psp_kp_pa_lokakarya_sekolahs'] || []).map((item) => {
          return item.sekolah;
        });

        if (this.form.tgl_pelaksanaan) {
          this.isDampinganSekolah = this.sekolah.length ? '1' : '0';
        }
      }

      // set durasi manual
      this.$set(this.form, 'durasi', 8);
    },

    reset() {
      this.$set(this, 'form', {
        rekaman_data: [],
      });
      this.$set(this, 'isDampinganSekolah', null);
      this.$set(this, 'pelapor', null);
      this.$set(this, 'petugas', []);
      this.$set(this, 'sekolah', []);
      this.durasis = [];
    },

    onPilihSekolah() {
      this.$refs.kandidat.open(this.sekolah).then((resp) => {
        this.sekolah = resp || {};
      });
    },

    onAddRekaman() {
      this.form.rekaman_data.push({ url_meeting: '' });
    },

    onDelRekaman(index) {
      this.form.rekaman_data.splice(index, 1);
      this.$delete(this.durasis, index);
    },

    onAddBerkas(berkas) {
      if (this.readOnly) return;

      this.berkas.jenis = berkas.key;
      this.berkas.title = berkas.label;
      this.berkas.reupload = false;
      this.berkas.id = '';

      this.$refs.berkas.open();
      this.$refs.berkas.stopLoading();
    },

    onDelBerkas(berkas) {
      if (this.readOnly) return;
      const id = this.$getDeepObj(berkas, `psp_kp_pa_lokakarya_berkas_id`);
      const pspKpPaId = this.$getDeepObj(this.pspKpPa, 'psp_kp_pa_id');
      this.$confirm(`Apakah Anda yakin ingin menghapus berkas <b>${berkas.judul}</b> ?`, 'Peringatan', {
        tipe: 'error',
      }).then(() => {
        this.delete({ pspKpPaId, id }).then(() => {
          this.$success('Berkas berhasil di hapus');
          this.$emit('refresh', false);
        });
      });
    },

    onAddBerkasSave(berkas) {
      if (this.berkas.reupload) {
        this.onReuploadBerkasSave(berkas);
        return;
      }

      const pspKpPaId = this.$getDeepObj(this.pspKpPa, 'psp_kp_pa_id');
      const params = new FormData();

      params.append('label', this.berkas.jenis);
      params.append('judul', berkas.judul);
      params.append('file', berkas.file);
      params.append('k_lokakarya_kegiatan_psp', this.kKegiatan);

      this.$refs.berkas.startLoading();
      this.upload({ pspKpPaId, params })
        .then(() => {
          this.$emit('refresh');
          this.$refs.berkas.close();
          this.$refs.berkas.stopLoading();
        })
        .catch(() => {
          this.$refs.berkas.stopLoading();
        });
    },

    onReuploadBerkas(berkas, file) {
      this.berkas.jenis = berkas.key;
      this.berkas.title = berkas.label;
      this.berkas.reupload = file.is_reupload || false;
      this.berkas.id = file.psp_kp_pa_lokakarya_berkas_id || '';

      this.$refs.berkas.open();
      this.$refs.berkas.stopLoading();
    },

    onReuploadBerkasSave(berkas) {
      const pspKpPaId = this.$getDeepObj(this.pspKpPa, 'psp_kp_pa_id');
      const berkasId = this.berkas.id || '';
      const params = new FormData();

      if (berkas.judul) {
        params.append('judul', berkas.judul);
      }

      params.append('label', this.berkas.jenis);
      params.append('file', berkas.file);
      params.append('k_lokakarya_kegiatan_psp', this.kKegiatan);

      this.$refs.berkas.startLoading();
      this.upload({ pspKpPaId, berkasId, params })
        .then(() => {
          this.$emit('refresh');
          this.$refs.berkas.close();
          this.$refs.berkas.stopLoading();
        })
        .catch(() => {
          this.$refs.berkas.stopLoading();
        });
    },

    onSelectFsp() {
      const fields = [
        {
          key: 'nama',
          icon: 'mdi-account',
          title: '',
          list: [
            {
              keys: ['ptk.nama'],
              class: 'body-1 blue--text',
            },
            {
              keys: ['ptk.email'],
              label: 'Akun SIMPKB: ',
              class: 'body-2 black--text',
            },
          ],
        },
      ];

      this.$refs.kandidat.open(fields).then((resp) => {
        this.fspLain = { ...(resp || {}) };
      });
    },

    getValue() {
      let form = Object.assign({}, this.form);

      if (+this.isTerlaksana !== 1) {
        return {
          k_lokakarya_kegiatan_psp: this.kKegiatan,
          is_terlaksana: 0,
        };
      }

      const keysInstrumens = Object.keys(form).filter((key) => /instrumen/.test(key));
      for (const key of keysInstrumens) {
        const keys = key.split('-');
        const tipe = keys[1];
        const kLokakaryaInstrumen = keys[2];

        let result = [];
        if (tipe === 'checkbox') {
          result = (form[key] || []).map((value) => {
            return {
              k_lokakarya_instrumen_psp: kLokakaryaInstrumen,
              k_lokakarya_opsi_psp: value,
              isian: form[`input-lain-${kLokakaryaInstrumen}-${value}`] || '',
            };
          });
        } else if (tipe === 'radio') {
          result = [
            {
              k_lokakarya_instrumen_psp: kLokakaryaInstrumen,
              k_lokakarya_opsi_psp: form[key],
              isian: form[`input-lain-${kLokakaryaInstrumen}-${form[key]}`] || '',
            },
          ];
        } else {
          result = [
            {
              k_lokakarya_instrumen_psp: kLokakaryaInstrumen,
              isian: form[key],
            },
          ];
        }

        if (form.instrumen) {
          form.instrumen = [...form.instrumen, ...result];
        } else {
          form.instrumen = result;
        }

        delete form[key];
      }

      if (this.$isObject(this.fspLain)) {
        form['psp_profil_id_lain'] = this.fspLain['psp_profil_id'];
      }

      if (+this.kKegiatan === 31) {
        if (+this.isDampinganSekolah === 1) {
          this.form.sekolah = this.sekolah.map((sekolah) => {
            return { sekolah_id: sekolah.sekolah_id };
          });
        } else {
          this.form['pkp_aktivitas'] = '';
          this.form['pkp_hasil'] = '';
          this.sekolah = [];
        }
      }

      return Object.assign({}, form, { k_lokakarya_kegiatan_psp: this.kKegiatan, is_terlaksana: 1 });
    },

    getDurasi(item, index) {
      if (!item.url_meeting) return;
      clearTimeout(this.debouce);
      this.debouce = setTimeout(() => {
        this.cekRekaman({ rekaman_url: item.url_meeting }).then((resp) => {
          const duration = (resp && resp.videoMediaMetadata && resp.videoMediaMetadata.durationMillis) || null;
          if (duration) {
            this.$set(this.durasis, index, this.$durasiWaktu(duration));
          }
        });
      }, 1000);
    },
  },
  watch: {
    initValue: 'initForm',
    'form.k_lokakarya_moda_psp': function(value) {
      if (value === 1 && !(this.initValue.rekaman_data || []).length) {
        this.$set(this.form, 'rekaman_data', []);
      }
    },
  },
};
</script>
